export const AdminTaskType = {
  kaplanImport: 'KaplanImport'
}

export const AdminTaskStatus = {
  pending: 'Pending',
  completed: 'Completed',
  failed: 'Failed',
  confirmed: 'Confirmed'
}


// WEBPACK FOOTER //
// ./src/constants/admin-task.js